import React, {
    useState,
    useEffect,

} from "react"
import { Typography } from './ot'
import StatsCard from './stats-card'
import clsx from "clsx";

const BaseListView1_4 = ({
    stats = [
        {
            value: 1250,
            label: "瀏覽次數",
            backgroundColor: "bg-blue-50",
            animationDuration: 2000,
            animationDelay: 0,
        },
        {
            value: 45,
            label: "撰寫文案",
            backgroundColor: "bg-green-50",
            animationDuration: 1500,
            animationDelay: 200,
        },
        {
            value: 320,
            label: "點擊次數",
            backgroundColor: "bg-blue-50",
            animationDuration: 2000,
            animationDelay: 0,
        },
        {
            value: 28,
            label: "複製次數",
            backgroundColor: "bg-green-50",
            animationDuration: 1500,
            animationDelay: 200,
        },
    ]

}, ref) => {


    return (
        <>
            {/* <StatsCard
                stats={stats}
                layout="horizontal"
                contentAlign="left"
                columnsPerRow={6}
                connection="connected"
                size="xs"
                enableAnimation={false}
                backgroundColor="bg-gray-50"
                responsiveColumns={{
                    xs: 12, sm: 12, md: 12, lg: 12, xl: 12, xxl: 12
                }}
            /> */}
            {stats?.length > 0 && <StatsCard
                stats={stats}
                layout="horizontal"
                contentAlign="left"
                // 以 6 欄為基準，但在極小螢幕改為單欄堆疊
                columnsPerRow={6}
                connection="connected"
                size="xs"
                enableAnimation={false}
                // 與外層背景一致（可依設計切換暗色）
                backgroundColor="bg-gray-50 dark:bg-gray-900"
                // 更語意化的響應式欄寬定義：
                // xs~sm: 12 -> 單列一張；md: 6 -> 一列兩張；lg: 4 -> 三張；xl: 3 -> 四張；2xl: 2 -> 六張（依組件邏輯）
                responsiveColumns={{
                    xs: 6,
                    sm: 6,
                    md: 4,
                    lg: 4,
                    xl: 3,
                    xxl: 2,
                }}
            // 可選：若 StatsCard 支援 className，讓卡片本身也能自帶 RWD 邊距/陰影
            // className={clsx(
            //     "rounded-2xl border border-gray-200/60 dark:border-gray-700/60",
            //     "shadow-sm",
            //     // 尊重使用者降低動態偏好
            //     "motion-safe:transition-all motion-safe:duration-200",
            //     // 卡片內文折行
            //     "[&_*]:break-words"
            // )}
            />}

        </>
    )
}

export default BaseListView1_4
